import React, { useState } from "react";
import { axiosInstance } from "../App";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.new_password !== formData.confirm_password) {
      toast.error("Password baru dan konfirmasi password tidak sama");
      return;
    }

    if (formData.new_password.length < 6) {
      toast.error("Password baru minimal 6 karakter");
      return;
    }

    setLoading(true);
    try {
      await axiosInstance.post("/auth/change-password", {
        old_password: formData.old_password,
        new_password: formData.new_password
      });
      
      toast.success("Password berhasil diubah");
      setFormData({ old_password: "", new_password: "", confirm_password: "" });
      onOpenChange(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Gagal mengubah password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1a1a1b] border-red-900/30">
        <DialogHeader>
          <DialogTitle className="text-red-50">Ubah Password</DialogTitle>
          <DialogDescription className="text-gray-400">
            Masukkan password lama dan password baru Anda
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="old_password" className="text-gray-300">Password Lama *</Label>
            <Input
              id="old_password"
              type="password"
              value={formData.old_password}
              onChange={(e) => setFormData({ ...formData, old_password: e.target.value })}
              required
              className="bg-[#0f0f10] border-red-900/30 text-white"
              data-testid="old-password-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="new_password" className="text-gray-300">Password Baru *</Label>
            <Input
              id="new_password"
              type="password"
              value={formData.new_password}
              onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
              required
              minLength={6}
              className="bg-[#0f0f10] border-red-900/30 text-white"
              data-testid="new-password-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm_password" className="text-gray-300">Konfirmasi Password Baru *</Label>
            <Input
              id="confirm_password"
              type="password"
              value={formData.confirm_password}
              onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
              required
              minLength={6}
              className="bg-[#0f0f10] border-red-900/30 text-white"
              data-testid="confirm-password-input"
            />
          </div>
          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1 border-red-900/30 text-white hover:bg-red-900/20"
              data-testid="cancel-button"
            >
              Batal
            </Button>
            <Button
              type="submit"
              className="flex-1 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
              disabled={loading}
              data-testid="submit-change-password-button"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Menyimpan...
                </>
              ) : (
                "Ubah Password"
              )}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ChangePasswordDialog;
